import React from 'react'
import { Nav } from './components'
import {History, Summary, Contact, Home, WhyWinner, Products } from './screens'
import styled from 'styled-components'
import initialise from './lib/initialise'


const ContentArea = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
  justify-content: center;
  align-items: center;
  width: 100%;
  overflow-x: hidden;
`

const App = () => {
  initialise()
  return (
    <React.Fragment>
      <Nav/>
      <ContentArea>
        <Home/>
        <Summary/>
        <History/>
        <WhyWinner/>
        <Products/>
        <Contact/> 
      </ContentArea>
    </React.Fragment>
  )
}

export default App